


































































































































import { FlowType, InventoryFlow } from '@tt4b/ttam-enums';
import { defineComponent, computed, ref } from '@vue/composition-api';
import SearchDeliveryTypeSwitch from '../search-delivery-type-switch/index.vue';
import { InventoryFlowListItem } from '../types';
import { PropType } from 'vue';
import { xor } from 'lodash-es';
import { convertRtlStyle } from '@tt4b/ttam-utils';

const name = 'ttam-placement-type-inventoryflow-list';

export default defineComponent({
  name,
  components: {
    SearchDeliveryTypeSwitch,
  },
  props: {
    value: {
      type: Array as PropType<InventoryFlow[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      defalut: false,
    },
    searchDeliveryType: {
      type: Number,
      default: 0,
    },
    searchDeliveryTypeDisabled: {
      type: Boolean,
      defalut: false,
    },
    searchDeliveryTypeVisible: {
      type: Boolean,
      defalut: false,
    },
    list: {
      type: Array as PropType<InventoryFlowListItem[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const _inventoryFlow = computed({
      get: () => props.value,
      set: val => emit('change', val),
    });

    const _searchDeliveryType = computed({
      get: () => props.searchDeliveryType || 0,
      set: val => emit('search-delivery-type-change', val),
    });

    const activeIndex = ref(0);

    const onInventoryFlowMouseOver = (idx: number) => {
      activeIndex.value = idx;
    };

    const onInventoryFlowClick = (item, idx: number) => {
      if (item.disabled) {
        return;
      }
      activeIndex.value = idx;
      _inventoryFlow.value = xor(_inventoryFlow.value, [item.id]);
    };

    const onLearnMoreClick = () => {
      emit('learn-more-click');
    };

    const onSearchDeliverlyTypeChange = v => {
      _searchDeliveryType.value = v;
    };

    // 预览的顺序
    // const previewIndex = ref(0);
    // const previewList = computed(() =>
    //   props.list.map(o => o.previewList.filter(x => !x.hide).map(x => ({ img: x.img, title: x.title })))
    // );
    // const previewListItem = computed(() => previewList.value?.[activeIndex.value]?.[previewIndex.value] || {});
    // const previewListItemLen = computed(() => previewList.value?.[activeIndex.value]?.length || 0);
    // const transformStyle = computed(() => (convertRtlStyle({
    //   transform: `translateX(-${previewIndex.value * 100}%)`,
    // })));

    // watch(activeIndex, val => {
    //   // 变化的时候要清空 previewIndex
    //   previewIndex.value = 0;
    // });

    // const onPreviewLeft = () => {
    //   if (previewIndex.value >= 1) {
    //     previewIndex.value--;
    //   } else {
    //     previewIndex.value = previewListItemLen.value - 1;
    //   }
    // };

    // const onPreviewRight = () => {
    //   if (previewIndex.value < previewListItemLen.value - 1) {
    //     previewIndex.value++;
    //   } else {
    //     previewIndex.value = 0;
    //   }
    // };

    return {
      name,
      activeIndex,
      // previewIndex,
      // previewListItem,
      // previewListItemLen,
      // previewList,
      // transformStyle,
      _inventoryFlow,
      _searchDeliveryType,
      FlowType,
      InventoryFlow,
      onInventoryFlowMouseOver,
      onSearchDeliverlyTypeChange,
      onInventoryFlowClick,
      onLearnMoreClick,
      // onPreviewLeft,
      // onPreviewRight,
    };
  },
});
